import HistoryDetailList from "./components/HistoryDetailList";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Button } from "antd-mobile";
import instance from "../../../../util/axios";

export default function CompletionListDetail() {
  const history = useHistory();
  const params = useParams<{
    fillingId: string;
  }>();
  const [isCutting, setIsCutting] = useState<boolean>(false);
  const descriptionCutting = [
    {
      fieldName: "completeTime",
      fieldShowName: "计划完成时间",
      width: 120,
    },
    {
      fieldName: "orderNo",
      fieldShowName: "批号",
      width: 120,
    },
    {
      fieldName: "skuName",
      fieldShowName: "产品",
      width: 120,
    },
    {
      fieldName: "allotQuantity",
      fieldShowName: "商品分配数量",
      width: 120,
    },
    {
      fieldName: "code",
      fieldShowName: "物料编码",
      width: 120,
    },
    {
      fieldName: "psiName",
      fieldShowName: "物料名称",
      inputType: 0,
      width: 120,
    },
    {
      fieldName: "length",
      fieldShowName: "长度",
      width: 120,
    },

    {
      fieldName: "bomTotalQuantity",
      fieldShowName: "所需下料数量",
      width: 120,
    },
    {
      fieldName: "practicalLength",
      fieldShowName: "实际下料长度",
      width: 120,
    },
    {
      fieldName: "practicalQuantity",
      fieldShowName: "实际下料数量",
      width: 120,
    },
    {
      fieldName: "outQuantity",
      fieldShowName: "已下料数量",
      width: 120,
    },
    {
      fieldName: "noOutQuantity",
      fieldShowName: "未下料数量",
      width: 120,
    },
  ];

  const descriptionNoCutting = [
    {
      fieldName: "orderTime",
      fieldShowName: "计划完成时间",
      width: 120,
    },
    {
      fieldName: "orderNo",
      fieldShowName: "批号",
      width: 120,
    },
    {
      fieldName: "dealerName",
      fieldShowName: "客户名称",
      width: 120,
    },
    {
      fieldName: "skuName",
      fieldShowName: "产品",
      width: 120,
    },
    {
      fieldName: "gear",
      fieldShowName: "排档方式",
      width: 120,
    },
    {
      fieldName: "gearModel",
      fieldShowName: "主管/档管规格",
      width: 120,
    },
    {
      fieldName: "color",
      fieldShowName: "表面处理",
      width: 120,
      inputType: 6,
      dictionary: "dict_rad_color",
    },
    {
      fieldName: "formulaName",
      fieldShowName: "图号",
      width: 120,
    },
    {
      fieldName: "length",
      fieldShowName: "长度",
      width: 120,
    },
    {
      fieldName: "totalQuantities",
      fieldShowName: "组数",
      width: 120,
    },
    {
      fieldName: "completionQuantity",
      fieldShowName: "已完成组数",
      width: 120,
    },
    {
      fieldName: "totalPieces",
      fieldShowName: "柱/档数",
      width: 120,
    },
    {
      fieldName: "completionPieces",
      fieldShowName: "已完成柱/档数",
      width: 120,
    },
  ];
  useEffect(() => {
    if (params?.fillingId) {
      instance
        .post(
          `/erp/sku/workshop/getCompletionFillingList?fillingId=${params?.fillingId}`
        )
        .then((resp) => {
          if (resp?.data?.Status === "1") {
            const data = resp?.data?.Data?.data?.[0];

            let baseConfigValue = "";
            instance
              .post(`oa/base/phone/getBaseConfig`, {
                name: "下料工序",
              })
              .then((resp) => {
                if (resp.data.Status === "1") {
                  baseConfigValue = resp.data.Data?.value;
                  if (baseConfigValue.includes(data?.procedureId!)) {
                    setIsCutting(true);
                  }
                }
              });
          }
        });
    }
  }, [params?.fillingId]);
  return (
    <>
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div style={{ flex: 1, overflowY: "auto" }}>
          <HistoryDetailList
            url={`/erp/sku/workshop/getCompletionFillingList?fillingId=${params?.fillingId}`}
            sorter={{ field: "createTime", order: "descend" }}
            descriptions={isCutting ? descriptionCutting : descriptionNoCutting}
          />
        </div>
        <Button
          style={{ width: "100%", zIndex: 99 }}
          type="primary"
          onClick={() => {
            history.push(
              `/erp/completion/historyNew/completionListAgain/${params?.fillingId}`
            );
          }}
        >
          再次填报
        </Button>
      </div>
    </>
  );
}
